export function mockGetTableData(params = {}) {
  const { pageNo = 1, pageSize = 50, name, sex } = params

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const arr = []

      for (let i = (pageNo - 1) * pageSize; i < pageNo * pageSize; ++i) {
        const obj = {
          id: i,
          name: `用户${i + 1}`,
          sex: (Math.round(Math.random() * 10) % 2) + '',
          birthday: Math.round(Math.random() * 1000000000000 + 600000000000),
          money: Math.round(Math.random() * 100000 + 5000),
          address: '浙江省杭州市',
        }

        if ((!name || obj.name.includes(name)) && (!sex || obj.sex === sex)) {
          arr.push(obj)
        }
      }

      resolve({
        data: arr,
        total: 1000,
      })
    }, 500)
  })
}

export function mockUpdTableData() {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(true)
    }, 500)
  })
}
